import React from 'react';
import {
  selectAssessmentSubmissionState,
  setAssessmentSubmissionState,
} from 'features/assessments/assessmentsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AssessmentSubmitDialog } from 'components/AssessmentSubmitDialog/AssessmentSubmitDialog';

interface AssessmentsSubmissionProps {
  jumpToQuestion: (questionNumber: number) => void;
  submitAnswers: () => void;
}

export const AssessmentsSubmission = ({
  jumpToQuestion,
  submitAnswers,
}: AssessmentsSubmissionProps) => {
  const { state, unansweredQuestion, requiredUnansweredQuestion } = useSelector(
    selectAssessmentSubmissionState,
  );
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(
      setAssessmentSubmissionState({
        state: null,
        unansweredQuestion: null,
        requiredUnansweredQuestion: null,
      }),
    );
  };

  const navigateToPage = (submissionState: 'required-skipped' | 'optional-skipped') => () => {
    const questionNumber =
      submissionState === 'required-skipped' ? requiredUnansweredQuestion : unansweredQuestion;
    if (questionNumber === null) return;
    jumpToQuestion(questionNumber);
    onClose();
  };

  switch (state) {
    case 'required-skipped':
      return (
        <AssessmentSubmitDialog
          variant="required-skipped"
          open
          onClose={onClose}
          onPrimaryAction={navigateToPage('required-skipped')}
        />
      );
    case 'optional-skipped':
      return (
        <AssessmentSubmitDialog
          variant="optional-skipped"
          open
          onClose={onClose}
          onPrimaryAction={navigateToPage('optional-skipped')}
          onSecondaryAction={submitAnswers}
        />
      );
    case 'completed':
      return (
        <AssessmentSubmitDialog
          variant="completed"
          open
          onClose={onClose}
          onPrimaryAction={submitAnswers}
        />
      );

    default:
      return null;
  }
};
